<template>
    <page>
        <tabs :activeTab="activeTab" :tabs="tabs" :onTabChange="onTabChange" />
    </page>
</template>

<script>
import Page from '@/components/layout/Page';
import Tabs from '@/components/layout/Tabs';

import Hubspots from './Hubspots/Hubspots';
import Events from './Events/Events';

export default {
    data() {
        return {
            activeTab: this.$route.params.tab || 'hubspot',
            tabs: [Hubspots, Events],
        };
    },
    components: {
        Page,
        Tabs,
    },
    methods: {
        onTabChange(tab) {
            this.$router.push(`/marketing/${tab.name}`, () => {});
        }
    }
}
</script>
